<template>
  <div>
    <div class="bg-gray rounded-md shadow mt-6">
      <div class="flex items-end justify-between py-1">
        <div class="flex items-center overflow-hidden shadow-inset">
          <div class="p-3 w-16 sm:w-19 flex-shrink-0">
            <ProfileImg class="w-full" />
          </div>
          <div class="pt-1 sm:pl-1 pr-3">
            <p class="mb-1 account-heading">
              <b>{{ user.name }}</b>
            </p>
            <p class="mb-1 account-heading email">
              <span>{{ user.email }}</span>
            </p>
          </div>
        </div>
        <div class="pl-1 pr-3 py-3 sm:pl-3 flex-shrink-0">
          <button
            class="py-1 px-2 block text-xs sm:text-base hover:underline text-primary whitespace-no-wrap focus:outline-none"
            @click="triggerLogout"
          >
            {{ $t('auth.logout') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ProfileImg from '@/assets/img/profile.svg';
import { LOGIN } from '@/router/routes.names';

export default {
  name: 'AccountWidget',
  components: {
    ProfileImg,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    ...mapActions('auth', ['logout']),
    async triggerLogout() {
      await this.logout();
      this.$router.push({ name: LOGIN });
    },
  },
};
</script>
<style lang="scss">
  .account-heading {
    @apply text-xs;
    line-height: 1.2;
    @screen sm {
      line-height: 1.4;
      @apply text-base;
    }
  }
  .shadow-inset {
    position: relative;
    &::after {
      content: '';
      display: block;
      z-index: 9;
      right: 0;
      width: 17px;
      height: 100%;
      top: 0;
      box-shadow: -18px 0px 7px -7px #f8f8f8 inset;
      position: absolute;
    }
  }
</style>
